var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvios(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53426 7.4006L0.220679 4.32901C0.115904 4.28498 0 4.36174 0 4.47516V12.6868C0 12.8943 0.126652 13.0809 0.319826 13.158L7.41352 15.9883C7.51795 16.03 7.63156 15.9532 7.63156 15.841V7.54676C7.63156 7.48294 7.59321 7.42537 7.53426 7.4006Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20199 6.52817L15.2713 3.55922C15.3983 3.50587 15.4017 3.32749 15.2768 3.26935L8.35545 0.0476002C8.21907 -0.0158667 8.06154 -0.0158667 7.92516 0.0476002L1.00381 3.26935C0.878876 3.32749 0.882279 3.50587 1.00935 3.55922L8.07862 6.52817C8.11805 6.54476 8.16256 6.54476 8.20199 6.52817Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64929 7.54676V15.841C8.64929 15.9532 8.76291 16.03 8.86733 15.9883L15.9611 13.158C16.1542 13.0809 16.2809 12.8943 16.2809 12.6868V4.47516C16.2809 4.36174 16.165 4.28498 16.0602 4.32901L8.74659 7.4006C8.68764 7.42537 8.64929 7.48294 8.64929 7.54676Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvios);
export default __webpack_public_path__ + "static/media/envios.d4e0d7eb615aa5f41cc2ff3dabf2420c.svg";
export { ForwardRef as ReactComponent };